import { useLazyQuery } from '@apollo/client';
import { GET_WORK_ORDER_OPERATION_PARTS_GQL } from 'lib/api/queries';
import { useCallback, useState } from 'react';

const defaultParts = {
  totalParts: 0,
  startAt: null,
  badParts: 0,
};

const useFetchJobSubmittedParts = () => {
  const [parts, setParts] = useState(defaultParts);

  const computeParts = useCallback((erpLaborTickets) => {
    const { totalParts, badParts, earliestClockIn } = erpLaborTickets.reduce(
      (acc, ticket) => {
        if (ticket.clockIn < acc.earliestClockIn) {
          acc.earliestClockIn = ticket.clockIn;
        }
        acc.totalParts += ticket.goodParts;
        acc.badParts += ticket.badParts;
        return acc;
      },
      {
        totalParts: 0,
        badParts: 0,
        earliestClockIn: erpLaborTickets?.[0]?.clockIn,
      }
    );

    setParts({
      totalParts,
      startAt: earliestClockIn,
      badParts,
    });
  }, []);

  const [requestJobSubmittedParts] = useLazyQuery(
    GET_WORK_ORDER_OPERATION_PARTS_GQL,
    {
      fetchPolicy: 'no-cache',
      notifyOnNetworkStatusChange: true,
      onCompleted: ({ erpLaborTickets }) => {
        if (erpLaborTickets?.length) {
          computeParts(erpLaborTickets);
        } else {
          setParts(defaultParts);
        }
      },
    }
  );

  const requestJobSubmittedPartsWrapper = useCallback(
    (workOrderOp) => {
      setParts(defaultParts);

      const { workOrderOperationRef, laborTickets } = workOrderOp;

      if (laborTickets?.length > 0) {
        computeParts(laborTickets);
      } else if (!laborTickets && workOrderOperationRef) {
        requestJobSubmittedParts({
          variables: {
            workOrderOperationRef,
          },
          skip: !workOrderOperationRef,
        });
      }
    },
    [requestJobSubmittedParts, computeParts]
  );

  return [
    requestJobSubmittedPartsWrapper,
    {
      parts,
    },
  ];
};

export default useFetchJobSubmittedParts;
